import { createTheme } from "@mui/material/styles";
import { PRIMARY } from "../utils/colors";

export const configureDesignSystem = createTheme({
  palette: {
    primary: {
      main: PRIMARY,
    },
    secondary: {
      main: PRIMARY,
    },
  },
  typography: {
    fontFamily: "Montserrat",
    allVariants: {
      textTransform: "none",
      letterSpacing: "0.05em",
    },
  },
  shape: { borderRadius: 4 },
  spacing: 8,
});
